module.exports = __webpack_public_path__ + "img/figure2-listbox.34df84ba.png";